import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { ActionComponent } from './action.component';

/**
 * A module containing objects associated with action components
 */

export class ActionModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    BsDropdownModule.forRoot(),
    CommonModule,
    FormsModule
  ],
  declarations: [ActionComponent],
  exports: [ActionComponent],
  providers: [BsDropdownConfig]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
